import type { ChangeEvent } from 'react';
import { Grid } from '@mui/material';

import type { CreatorType } from '../filterTypes';
import { FiltersBlock } from './FiltersBlock';
import { icons } from './Icons';

interface FindListingsSectionProps {
  creator: CreatorType;
  isMyAgency?: boolean;
  isTariffFree: boolean;
  keywords?: string;
  myFriends?: boolean;
  onCreatorChange: (value: CreatorType, name?: string) => void;
  onKeywordsChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onMyAgencyChange: (value: boolean) => void;
  onMyFriendsChange: (value: boolean) => void;
}

export const FindListingsSection = ({
  creator,
  isMyAgency,
  isTariffFree,
  keywords,
  myFriends,
  onCreatorChange,
  onKeywordsChange,
  onMyAgencyChange,
  onMyFriendsChange,
}: FindListingsSectionProps) => {
  return (
    <>
      {!isTariffFree && (
        <Grid item xs={12}>
          <FiltersBlock
            icon={<icons.FindListings />}
            name='findListings'
            type='checkbox'
            title='Find Listings'
            activeButton={creator}
            onClick={onCreatorChange}
            dataQa='find_listings'
            isMyAgency={isMyAgency}
            changeMyAgency={onMyAgencyChange}
            myFriends={myFriends}
            changeMyFriends={onMyFriendsChange}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <FiltersBlock
          icon={<icons.Keywords />}
          name='keywords'
          type='input'
          title='Keywords'
          activeButton={keywords}
          onChange={onKeywordsChange}
          dataQa='keywords'
        />
      </Grid>
    </>
  );
};
